import { ModeleDeBase } from "./ModeleDeBase";

export interface IVariableEnvironnementValueCDS {
  environmentvariablevalueid: string;
  _environmentvariabledefinitionid_value: string;
  value: string;
}

export class VariableEnvironnementValue extends ModeleDeBase {
  definitionId: string; // fk
  valeur: string;

  constructor(entity: IVariableEnvironnementValueCDS) {
    super(entity.environmentvariablevalueid);

    // TODO: Utiliser le nom "final" du champ lorsqu'il sera connu
    this.definitionId = entity._environmentvariabledefinitionid_value;
    this.valeur = entity.value;
  }

  serialiser(): IVariableEnvironnementValueCDS {
    return {
      environmentvariablevalueid: this.id,
      _environmentvariabledefinitionid_value: this.definitionId,
      value: this.valeur,
    };
  }
}
